(function () {
  'use strict';
  var cfg = window.t8rvConfig || {};
  var sectionId = cfg.sectionId || '';
  var i18n = cfg.i18n || {};
  var locale = cfg.locale;

  // ---- Reviews list modal (browse / paginate reviews) ----
  (function () {
    var root = document.getElementById('t8rv-' + sectionId);
    if (!root) return;
    var dataEl = document.getElementById('t8rvData-' + sectionId);
    if (!dataEl) return;
    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var reviews = data.reviews || [];
    var meta = data.meta || {};
    var totalReviewCount = typeof meta.count === 'number' && meta.count > 0 ? meta.count : reviews.length;
    var palette = ['#B08968', '#7B9E89', '#C97064', '#5C80BC', '#9C6644', '#4A7C59', '#A26769', '#3C6E71', '#8E6C88', '#6B7A8F'];

    function avatarColor(name) {
      var str = name || '?';
      var hash = 0;
      for (var i = 0; i < str.length; i++) { hash = str.charCodeAt(i) + ((hash << 5) - hash); }
      var idx = Math.abs(hash) % palette.length;
      return palette[idx];
    }
    function initials(name) {
      if (!name) return '?';
      return name.trim().charAt(0).toUpperCase();
    }
    function escapeHTML(str) {
      return (str || '').replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function formatDate(d) {
      try {
        var parts = d.split('-');
        var dt = new Date(Date.UTC(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10)));
        return new Intl.DateTimeFormat(locale || undefined, { year: 'numeric', month: 'long' }).format(dt);
      } catch (e) { return d; }
    }
    function starsHTML(r) {
      return '<span class="rating" role="img"><span aria-hidden="true" class="rating-star" style="--rating:' + r + ';--rating-max:5;--rating-decimal:0;"></span></span>';
    }
    function cardHTML(rv) {
      var name = rv.a || '';
      var sourceLine = '';
      if (rv.s && rv.s !== 'TRiBUTE8' && rv.s !== 'Shop' && rv.s !== 'Website') {
        sourceLine = ' &middot; ' + (i18n.originallyPostedTpl || '').replace('%%SRC%%', rv.s);
      }
      var badge = rv.v ? '<span class="t8rv__badge">' + (i18n.verified || '') + '</span>' : '';
      return '' +
        '<div class="t8rv__card">' +
          '<div class="t8rv__card-top">' +
            '<span class="t8rv__avatar" style="background:' + avatarColor(name) + ';">' + initials(name) + '</span>' +
            '<div class="t8rv__card-meta">' +
              '<span class="t8rv__author">' + escapeHTML(name) + '</span>' +
              '<span class="t8rv__date">' + formatDate(rv.d) + sourceLine + '</span>' +
            '</div>' +
          '</div>' +
          '<div class="t8rv__card-rating">' + starsHTML(rv.r) + badge + '</div>' +
          '<p class="t8rv__card-body">' + escapeHTML(rv.b) + '</p>' +
        '</div>';
    }

    var pageSize = 10;
    var currentPage = 1;
    var totalPages = Math.max(1, Math.ceil(totalReviewCount / pageSize));
    var listEl = document.getElementById('t8rvList-' + sectionId);
    var pagEl = document.getElementById('t8rvPagination-' + sectionId);

    var fullDataPromise = null;
    function ensureFullData() {
      if (fullDataPromise) return fullDataPromise;
      fullDataPromise = fetch(window.location.pathname + '?section_id=reviews-full-data')
        .then(function (res) {
          if (!res.ok) throw new Error('t8rv: full data fetch failed with status ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var match = html.match(/<script type="application\/json" id="t8rvFullData">([\s\S]*?)<\/script>/);
          if (!match || !match[1]) throw new Error('t8rv: full data payload not found in response');
          var fullData = JSON.parse(match[1]);
          if (fullData && fullData.reviews && fullData.reviews.length) {
            reviews = fullData.reviews;
            totalReviewCount = reviews.length;
            totalPages = Math.max(1, Math.ceil(totalReviewCount / pageSize));
          }
        })
        .catch(function (err) {
          fullDataPromise = null;
          throw err;
        });
      return fullDataPromise;
    }

    function buildPageList(current, total) {
      var range = [];
      for (var i = 1; i <= total; i++) {
        if (i === 1 || i === total || (i >= current - 1 && i <= current + 1)) range.push(i);
      }
      var out = [];
      var last = 0;
      range.forEach(function (p) {
        if (last && p - last > 1) out.push('...');
        out.push(p);
        last = p;
      });
      return out;
    }
    function renderPagination() {
      if (totalPages <= 1) { pagEl.innerHTML = ''; return; }
      var pages = buildPageList(currentPage, totalPages);
      var html = '';
      html += '<button type="button" class="t8rv__page-btn" data-page="' + (currentPage - 1) + '"' + (currentPage === 1 ? ' disabled' : '') + ' aria-label="' + (i18n.prev || '') + '">&larr;</button>';
      pages.forEach(function (p) {
        if (p === '...') {
          html += '<span class="t8rv__page-ellipsis">&hellip;</span>';
        } else {
          html += '<button type="button" class="t8rv__page-btn' + (p === currentPage ? ' is-current' : '') + '" data-page="' + p + '"' + (p === currentPage ? ' aria-current="page"' : '') + '>' + p + '</button>';
        }
      });
      html += '<button type="button" class="t8rv__page-btn" data-page="' + (currentPage + 1) + '"' + (currentPage === totalPages ? ' disabled' : '') + ' aria-label="' + (i18n.next || '') + '">&rarr;</button>';
      pagEl.innerHTML = html;
    }
    function renderPage(n) {
      var targetPage = Math.max(1, Math.min(n, totalPages));
      var start = (targetPage - 1) * pageSize;
      var haveEnough = reviews.length >= Math.min(start + pageSize, totalReviewCount);
      if (!haveEnough) {
        ensureFullData().then(function () {
          renderPage(targetPage);
        }).catch(function () {
          totalPages = Math.max(1, Math.ceil(reviews.length / pageSize));
          currentPage = Math.max(1, Math.min(targetPage, totalPages));
          var s = (currentPage - 1) * pageSize;
          var fallbackItems = reviews.slice(s, s + pageSize);
          listEl.innerHTML = fallbackItems.map(cardHTML).join('');
          renderPagination();
        });
        return;
      }
      currentPage = targetPage;
      var items = reviews.slice(start, start + pageSize);
      listEl.innerHTML = items.map(cardHTML).join('');
      renderPagination();
    }
    pagEl.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-page]');
      if (!btn || btn.disabled) return;
      renderPage(parseInt(btn.getAttribute('data-page'), 10));
      var panel = root.querySelector('.t8rv__modal-panel');
      if (panel) panel.scrollTop = 0;
    });
    renderPage(1);

    var openBtn = document.getElementById('t8rvOpen-' + sectionId);
    var showAllBtn = document.getElementById('t8rvShowAll-' + sectionId);
    var modal = document.getElementById('t8rvModal-' + sectionId);
    if (modal.parentNode !== document.body) { document.body.appendChild(modal); }
    var t8rvSavedScrollY = 0;
    function openModal() {
      modal.classList.add('is-open');
      document.body.classList.add('t8rv-modal-open');
      t8rvSavedScrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + t8rvSavedScrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.addEventListener('keydown', onKeydown);
      renderPage(1);
      var panel = modal.querySelector('.t8rv__modal-panel');
      if (panel) panel.scrollTop = 0;
    }
    function closeModal() {
      modal.classList.remove('is-open');
      document.body.classList.remove('t8rv-modal-open');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      window.scrollTo(0, t8rvSavedScrollY);
      document.removeEventListener('keydown', onKeydown);
    }
    function onKeydown(e) { if (e.key === 'Escape') closeModal(); }
    if (openBtn) openBtn.addEventListener('click', openModal);
    if (showAllBtn) showAllBtn.addEventListener('click', openModal);
    modal.querySelectorAll('[data-t8rv-close]').forEach(function (el) { el.addEventListener('click', closeModal); });
  })();

  // ---- Write-a-review modal ----
  (function () {
    var toggle = document.getElementById('t8rvWriteToggle-' + sectionId);
    var modal = document.getElementById('t8rvWriteModal-' + sectionId);
    var form = document.getElementById('t8rvWriteForm-' + sectionId);
    var stars = document.querySelectorAll('#t8rvStars-' + sectionId + ' .t8rv-write__star');
    var ratingInput = document.getElementById('t8rvRating-' + sectionId);
    var msg = document.getElementById('t8rvWriteMsg-' + sectionId);
    var submitBtn = document.getElementById('t8rvWriteSubmit-' + sectionId);
    if (!toggle || !modal || !form) return;

    if (modal.parentNode !== document.body) { document.body.appendChild(modal); }

    function onKeydown(e) { if (e.key === 'Escape') closeModal(); }

    var t8rvWriteSavedScrollY = 0;
    function openModal() {
      modal.classList.add('is-open');
      document.body.classList.add('t8rv-modal-open');
      t8rvWriteSavedScrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + t8rvWriteSavedScrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      toggle.setAttribute('aria-expanded', 'true');
      document.addEventListener('keydown', onKeydown);
      var firstField = form.querySelector('#t8rvName-' + sectionId);
      if (firstField) firstField.focus();
    }
    function closeModal() {
      modal.classList.remove('is-open');
      document.body.classList.remove('t8rv-modal-open');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      window.scrollTo(0, t8rvWriteSavedScrollY);
      toggle.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', onKeydown);
    }
    toggle.addEventListener('click', openModal);
    modal.querySelectorAll('[data-t8rv-write-close]').forEach(function (el) { el.addEventListener('click', closeModal); });

    function setRating(val) {
      ratingInput.value = val;
      stars.forEach(function (s) {
        var v = parseInt(s.getAttribute('data-value'), 10);
        if (v <= val) { s.classList.add('is-filled'); s.setAttribute('aria-pressed', 'true'); }
        else { s.classList.remove('is-filled'); s.setAttribute('aria-pressed', 'false'); }
      });
    }
    stars.forEach(function (s) {
      s.addEventListener('click', function () {
        setRating(parseInt(s.getAttribute('data-value'), 10));
      });
    });

    function showMsg(text, isError) {
      msg.textContent = text;
      msg.classList.toggle('is-error', !!isError);
      msg.classList.toggle('is-success', !isError);
    }

    // The verification backend (hosted off-platform on Siteground/PHP) always replies
    // in English. On non-English storefronts (e.g. German) we must not surface its raw
    // message text to the shopper -- prefer our localized i18n strings instead. English
    // storefronts keep the more detailed backend text as before.
    var isEnglishLocale = !locale || locale.toLowerCase().indexOf('en') === 0;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var rating = parseInt(ratingInput.value, 10) || 0;
      if (rating < 1) {
        showMsg(i18n.writeErrorRating || '', true);
        return;
      }
      var payload = {
        product_id: cfg.productId,
        rating: rating,
        title: form.title.value,
        body: form.body.value,
        author: form.author.value,
        email: form.email.value,
        website: form.website.value
      };
      submitBtn.disabled = true;
      var submittingText = i18n.writeSubmitting || '';
      var originalText = submitBtn.textContent;
      submitBtn.textContent = submittingText;
      showMsg('', false);
      fetch('https://tribute8.etienneastier.com/reviews-api/submit-review.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (result) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
          if (result.ok && result.data && result.data.success) {
            setRating(0);
            var successText = isEnglishLocale
              ? (result.data.message || i18n.writeSuccess || '')
              : (i18n.writeSuccess || result.data.message || '');
            showMsg(successText, false);
            form.hidden = true;
          } else {
            var errText = isEnglishLocale
              ? ((result.data && result.data.error) || i18n.writeErrorGeneric || '')
              : (i18n.writeErrorGeneric || (result.data && result.data.error) || '');
            showMsg(errText, true);
          }
        })
        .catch(function () {
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
          showMsg(i18n.writeErrorGeneric || '', true);
        });
    });
  })();
})();
